import React from 'react';
import Chip from '@material-ui/core/Chip';

const getStyle = (status) => {
  switch (status) {
    case 'A Vencer':
      return {
        backgroundColor: '#FFD700',
      };
    case 'Liquidado':
      return {
        backgroundColor: '#32CD32',
      };
    case 'Devedor':
      return {
        backgroundColor: '#FF0000',
      };
    case 'Em Parcelamento':
      return {
        backgroundColor: '#696969',
      };
    case 'Declaração Zerada':
      return {
        backgroundColor: '#181a19',
      };
    default:
      return {
        backgroundColor: '#000000',
      };
  }
};

function components(props) {
  const { status } = props;
  return <Chip label={status} color="primary" style={getStyle(status)} />;
}

export default components;
